(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/utils/utils.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/utils/utils.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs.ticketsValidate.utils.getShortNameByTicketId = ticketId => {
  let shortName;
  try {
    shortName = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(ticketId).shortName;
  } catch (e) {}
  return shortName;
};
svs.ticketsValidate.utils.getBrandByTicketId = ticketId => {
  let brand;
  try {
    brand = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(ticketId).branding;
  } catch (e) {}
  return brand;
};
svs.ticketsValidate.utils.leaveInAccountDialog = _ref => {
  let onValidateNewTicket = _ref.onValidateNewTicket,
    brand = _ref.brand,
    trackType = _ref.trackType;
  return svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'thumbs-up',
    title: 'Toppen!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Nu vilar din vinst tryggt på ditt spelkonto och kan bland annat användas för att köpa nya spel.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'All information om dina köp och vinster hittar du i Mina spel.'
    }],
    actions: [{
      title: 'Rätta ny lott',
      callback: (e, forms, dialog) => {
        dialog === null || dialog === void 0 || dialog.close();
        onValidateNewTicket(e, 'B');
      }
    }, {
      title: 'Jag är klar',
      callback: (e, forms, dialog) => {
        svs.ticketgames.ticketUtility.utils.tracking.trackValidateKeepWinChosen(trackType);
        dialog === null || dialog === void 0 || dialog.close();
        let ticketsValidateDoneKeepWinUrl;
        switch (brand) {
          case 'triss':
            ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateDoneKeepWinTriss');
            break;
          case 'skrapspel':
            ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateDoneKeepWinSkrapspel');
            break;
          default:
            ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateManual');
        }
        svs.utils.url.navigate(ticketsValidateDoneKeepWinUrl);
      }
    }]
  }));
};
svs.ticketsValidate.utils.navigateToVoucher = _ref2 => {
  let ticketType = _ref2.ticketType,
    multiBuyId = _ref2.multiBuyId,
    voucherId = _ref2.voucherId,
    value = _ref2.value,
    expirationDate = _ref2.expirationDate,
    _ref2$tickets = _ref2.tickets,
    tickets = _ref2$tickets === void 0 ? 1 : _ref2$tickets;
  let queryParams = {
    price: value,
    tickets
  };
  if (expirationDate) {
    queryParams = _objectSpread(_objectSpread({}, queryParams), {}, {
      expirationDate
    });
  }
  const path = svs.core.urlMapping.get('trissVoucher_Confirmed').replace(':ticketType', ticketType).replace(':multiBuyId', multiBuyId).replace(':voucherId', voucherId);
  const queryString = Object.entries(queryParams).map(_ref3 => {
    let _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return "".concat(key, "=").concat(value);
  }).join('&');
  svs.utils.url.navigate("".concat(path, "?").concat(queryString));
};
svs.ticketsValidate.utils.setWonTicketFlag = ticketId => {
  svs.components.Storage.browser.set('ticketsValidate', "wonTicket_".concat(ticketId), {
    canRedeem: true
  }, svs.components.Storage.constants.EXPIRES_24H);
};
svs.ticketsValidate.utils.setRedeemedWonTicket = (ticketId, _ref5) => {
  let redeemType = _ref5.redeemType,
    data = _ref5.data;
  svs.components.Storage.browser.set('ticketsValidate', "wonTicket_".concat(ticketId), {
    canRedeem: false,
    redeemType,
    data
  }, svs.components.Storage.constants.EXPIRES_24H);
};
svs.ticketsValidate.utils.getWonTicketState = ticketId => svs.components.Storage.browser.get('ticketsValidate', "wonTicket_".concat(ticketId));

 })(window);